import {Row, Col ,Container} from 'react-grid-system';
import '../Assests/project.css';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

import st1 from '../Assests/images/st1.jpeg'; 
import st2 from '../Assests/images/st2.jpeg';
import st4 from '../Assests/images/st4.jpeg';
import st5 from '../Assests/images/st5.jpeg';
import turkey1 from '../Assests/images/turkey1.png';
import turkey from '../Assests/images/turkey.png';
import turkey3 from '../Assests/images/turkey3.png';
import 'aos/dist/aos.css';
import 'react-slideshow-image/dist/styles.css' 

const Projects = () => {
            
        return (
            <Container fluid className="bodyP" >
                <Row >
                <Col xs sm="12" md lg="12">
                  <h1 className="abt" >Projects</h1>
                </Col>
                </Row>
                <br/>
                <br/>
                <div>
                <AliceCarousel autoPlay autoPlayInterval="4000">
      <img src={st1} className="sliderimg" alt=""/>
      <img src={st2} className="sliderimg" alt=""/>
      <img src={st4} className="sliderimg" alt=""/>
      <img src={st5} className="sliderimg" alt=""/>
      <img src={turkey} className="sliderimg" alt=""/>
      <img src={turkey1} className="sliderimg" alt=""/>
      <img src={turkey3} className="sliderimg" alt=""/>
     
    </AliceCarousel>
      </div>
                
                {/* <ul class="img-list">
                <li><img src={exp}/><p className="lip">Expense Tracker(Android)</p></li>
                <li><img src={st}/><p className="lip">simplitaught site(React)</p></li>
                <li><img src={turkey}/><p className="lip">Responsive site(React)</p></li>
                </ul>
                <br/> */}
               
               
                
               
               
               
                
            </Container>
        );
    }
export default Projects;